const es_cochesnet = {
  POWERED_BY: "Servicio ofrecido por",
};

export default es_cochesnet;
